import { TranslateLoader } from '@ngx-translate/core';
import {Observable, of, switchMap} from 'rxjs';
import { tap } from 'rxjs/operators';

import {version} from '../../../../package.json';
import {MirandaApiService} from '../../services/miranda-api.service';
import {inject} from '@angular/core';
import {SessionStorageService} from 'ngx-webstorage';

export class TranslateLSLoader implements TranslateLoader {
  private mirandaApiService: MirandaApiService = inject(MirandaApiService);
  private sessionStorageService: SessionStorageService = inject(SessionStorageService);

  public getTranslation(lang: string): Observable<any> {
    const userType = this.sessionStorageService.retrieve('userType');

    if (userType !== 'dispatcher') {
      return of({});
    }

    const translations = localStorage.getItem(`${lang}---${version}`);

    if (translations) {
      return of(JSON.parse(translations));
    }
    else {
      return this.mirandaApiService.getOperatorTranslation().pipe(
        switchMap(rsp => this.mirandaApiService.getUniversal(rsp?.data?.url)),
        tap(translation => {
          for (const key of Object.keys(localStorage)) {
            if (key.split('---')[0] === lang) {
              localStorage.removeItem(key);
            }
          }
          localStorage.setItem(`${lang}---${version}`, JSON.stringify(translation));
        })
      );
    }
  }
}
